import script from "./CensusDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CensusDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./CensusDetailsPage.vue?vue&type=style&index=0&id=7cbd8ae6&scoped=true&lang=scss"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cbd8ae6"]])

export default __exports__